import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChargeEditInput, ChargeEditResult } from '../charges.component';

@Component({
    selector: 'kiene-edit-charge-dialog',
    templateUrl: './edit-charge-dialog.component.html',
    styleUrls: ['./edit-charge-dialog.component.scss'],
})
export class EditChargeDialogComponent implements OnInit {
    chargeCtrl: FormControl = new FormControl();
    mhdCtrl: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<EditChargeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public input: ChargeEditInput,
    ) {}

    ngOnInit(): void {
        if (this.input?.charge?.mhd) {
            this.mhdCtrl.setValue(this.input.charge.mhd);
        }

        if (this.input?.charge?.charge) {
            this.chargeCtrl.setValue(this.input.charge.charge);
        }
    }

    close() {
        const res = new ChargeEditResult();
        res.confirm = false;

        this.dialogRef.close(res);
    }

    save(): void {
        const res = new ChargeEditResult();
        res.confirm = true;
        res.charge = this.input.charge;
        res.charge.charge = this.chargeCtrl.value;
        res.charge.mhd = this.mhdCtrl.value;
        this.dialogRef.close(res);
    }
}
